import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back_arrow_circle_small",
  "use": "back_arrow_circle_small-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"back_arrow_circle_small\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" transform=\"translate(1 1)\"><circle cx=\"8\" cy=\"8\" r=\"8\" /><path d=\"M8 4.8 4.8 8 8 11.2M11.2 8H4.8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol